import keycloak from '@/keycloak';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import TreeView from '@mui/lab/TreeView';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import SidebarItem from './SidebarItem';

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('sidebar');
  const isAdmin =
    keycloak.hasResourceRole('ADMIN', process.env.REACT_APP_KEYCLOAK_CLIENT_ID) || process.env.REACT_APP_ENV === 'dev';
  const selectedTree = (endpoint: string) => {
    if (endpoint.startsWith('/overhead')) {
      return '3';
    }
    if (endpoint.startsWith('/provider')) {
      return '2';
    }
    switch (endpoint) {
      case '/general':
        return '1';
      case '/providers':
        return '2';
      case '/overhead':
        return '3';
      case '/final-version':
        return '4';
      case '/available-percentage':
        return '5';
      case '/project-priority':
        return '6';
      case '/resource-donors':
        return '7';
      case '/specific-allocation':
        return '8';
      case '/allocation-priority':
        return '9';
      case '/position-restriction':
        return '10';
      case '/profile':
        return '11';
      case '/consider-collaborator':
        return '19';
      case '/historic':
        return '20';
      case '/extra-collaborator':
        return '21';
      case '/allocation-constraint':
        return '22';
      case '/disregard-events':
        return '23';
      default:
        return '1';
    }
  };
  return (
    <TreeView
      selected={selectedTree(location.pathname)}
      defaultExpanded={['1']}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpandIcon={<ArrowRightIcon />}
      defaultEndIcon={<div style={{ width: 24 }} />}
      sx={{ height: 264, flexGrow: 1, width: 280, paddingLeft: '2rem' }}
    >
      <>
        <Typography variant="h2" sx={{ marginY: '1rem', fontWeight: 'bold' }}>
          {t('processing')}
        </Typography>
        <SidebarItem
          active={selectedTree(location.pathname) === '1'}
          nodeId="1"
          labelText={t('general')}
          labelInfo="2,294"
          color="#E3742F"
          bgColor="#FCEFE3"
          badgeColor="warning"
          onClick={() => {
            navigate('general');
          }}
        />
        <SidebarItem
          active={selectedTree(location.pathname) === '2'}
          nodeId="2"
          labelText={t('providers')}
          labelInfo="2,294"
          color="#E3742F"
          bgColor="#FCEFE3"
          badgeColor="warning"
          onClick={() => {
            navigate('providers');
          }}
        />
        <SidebarItem
          active={selectedTree(location.pathname) === '3'}
          nodeId="3"
          labelText={t('overhead')}
          labelInfo="2,294"
          color="#E3742F"
          bgColor="#FCEFE3"
          badgeColor="warning"
          onClick={() => {
            navigate('overhead');
          }}
        />
      </>
      <>
        <Typography variant="h2" sx={{ marginY: '1rem', fontWeight: 'bold' }}>
          {t('sharing')}
        </Typography>
        <SidebarItem
          active={selectedTree(location.pathname) === '4'}
          nodeId="4"
          labelText={t('final.version')}
          color="#E3742F"
          bgColor="#FCEFE3"
          onClick={() => {
            navigate('final-version');
          }}
        />
      </>
      <>
        <Typography variant="h2" sx={{ marginY: '1rem', fontWeight: 'bold' }}>
          {t('rules')}
        </Typography>
        <SidebarItem
          active={selectedTree(location.pathname) === '5'}
          nodeId="5"
          labelText={t('available.percentage')}
          color="#E3742F"
          bgColor="#FCEFE3"
          onClick={() => {
            navigate('available-percentage');
          }}
        />
        <SidebarItem
          active={selectedTree(location.pathname) === '6'}
          nodeId="6"
          labelText={t('client.priority')}
          color="#E3742F"
          bgColor="#FCEFE3"
          onClick={() => {
            navigate('project-priority');
          }}
        />
        <SidebarItem
          active={selectedTree(location.pathname) === '7'}
          nodeId="7"
          labelText={t('resource.donors')}
          color="#E3742F"
          bgColor="#FCEFE3"
          onClick={() => {
            navigate('resource-donors');
          }}
        />
        <SidebarItem
          active={selectedTree(location.pathname) === '8'}
          nodeId="8"
          labelText={t('specific.allocation')}
          color="#E3742F"
          bgColor="#FCEFE3"
          onClick={() => {
            navigate('specific-allocation');
          }}
        />
        <SidebarItem
          active={selectedTree(location.pathname) === '9'}
          nodeId="9"
          labelText={t('allocation.priority')}
          color="#E3742F"
          bgColor="#FCEFE3"
          onClick={() => {
            navigate('allocation-priority');
          }}
        />
        <SidebarItem
          active={selectedTree(location.pathname) === '10'}
          nodeId="10"
          labelText={t('position.restriction')}
          color="#E3742F"
          bgColor="#FCEFE3"
          onClick={() => {
            navigate('position-restriction');
          }}
        />
        <SidebarItem
          active={selectedTree(location.pathname) === '22'}
          nodeId="22"
          labelText={t('allocation.constraint')}
          color="#E3742F"
          bgColor="#FCEFE3"
          onClick={() => {
            navigate('allocation-constraint');
          }}
        />
      </>
      <>
        <Typography variant="h2" sx={{ marginY: '1rem', fontWeight: 'bold' }}>
          {t('configs')}
        </Typography>
        <SidebarItem
          active={selectedTree(location.pathname) === '19'}
          nodeId="19"
          labelText={t('consider.collaborator')}
          color="#e3742f"
          bgColor="#fcefe3"
          onClick={() => {
            navigate('consider-collaborator');
          }}
        />
        <SidebarItem
          active={selectedTree(location.pathname) === '20'}
          nodeId="20"
          labelText={t('upload.historic')}
          color="#E3742F"
          bgColor="#FCEFE3"
          onClick={() => {
            navigate('historic');
          }}
        />
        <SidebarItem
          active={selectedTree(location.pathname) === '21'}
          nodeId="21"
          labelText={t('extra.collaborator')}
          color="#E3742F"
          bgColor="#FCEFE3"
          onClick={() => {
            navigate('extra-collaborator');
          }}
        />
        <SidebarItem
          active={selectedTree(location.pathname) === '23'}
          nodeId="23"
          labelText={t('disregard.events')}
          color="#E3742F"
          bgColor="#FCEFE3"
          onClick={() => {
            navigate('disregard-events');
          }}
        />
      </>
      {isAdmin && (
        <>
          <Typography variant="h2" sx={{ marginY: '1rem', fontWeight: 'bold' }}>
            {t('admin')}
          </Typography>
          <SidebarItem
            active={selectedTree(location.pathname) === '11'}
            nodeId="11"
            labelText={t('profile')}
            color="#E3742F"
            bgColor="#FCEFE3"
            onClick={() => {
              navigate('profile');
            }}
          />
        </>
      )}
    </TreeView>
  );
}
